var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['hero', 'is-fullheight', 'is-bold', _vm.color],attrs:{"v":""}},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }